import { createGlobalStyle } from 'styled-components';
import { palette, font } from 'styled-theme';
// import 'antd/dist/antd.css';

const GlobalStyles = createGlobalStyle`
  /* Login As Banner Styles */
  .login-as-banner-visible {
    padding-top: 40px;
  }
  
  .login-as-banner-visible .isoContentMainLayout {
    margin-top: 40px;
  }
`;

export default GlobalStyles;
